import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SolutionRuleStateService } from '..';

@Injectable({
  providedIn: 'root',
})
export class SolutionRuleActionEventsService {
  canEdit$ = new BehaviorSubject<boolean>(false);
  validationRequest$ = new Subject<Record<string, string>>();
  validationResponse$ = new Subject<Record<string, string>>();

  testRunValidationRequest$ = new Subject<void>();
  testRunValidationResponse$ = new Subject<boolean>();

  workflowUpdateValidationRequest$ = new Subject<string>();
  workflowUpdateValidationResponse$ = new Subject<boolean>();

  constructor(readonly solutionRuleState: SolutionRuleStateService) {}

  checkValidity(errors: Record<string, string>) {
    this.validationRequest$.next(errors);
  }

  // Call this when a rule is switching between a custom solution context.
  changeSolutionContext() {
    this.solutionRuleState.solutionAdditionalProperties$.next({});
    this.solutionRuleState.solutionActions$.next([]);
  }
}
